import React from 'react';
import PropTypes from 'prop-types';

import ActionsMenuItem from '@components/asset/modal/tabs/workflow/attachment_details/versions_sidebar/actions_menu_item';
import { rollbackVersions } from '@api/v4/attachments/versions_NEW';
import download from '@helpers/download';

const ActionsMenu = ({
  checkedInStatus,
  componentClass,
  initializeTab,
  isLatestVersion,
  setShowActionsMenu,
  setShowCheckinCheckout,
  setVersionsActionLoading,
  sidebarCard,
  updateFetchControllers,
}) => {
  const handleUpdateCurrentVersion = () => {
    rollbackVersions({ versionKey: sidebarCard.id }, updateFetchControllers)
      .then((response) => {
        if (response && !response.ok) {
          initializeTab();
        }
        setVersionsActionLoading(false);
      })
      .catch((err) => {
        setVersionsActionLoading(false);
        console.log(err);
      });
  };

  const handleDownload = () => {
    const { url, filename, metadata } = sidebarCard.version_details;
    download(url, { filename, filetype: metadata.mime_type });
  };

  const handleOnSelect = (name) => {
    setShowActionsMenu(false);

    if (name === 'checked_in' || name === 'checked_out') {
      setVersionsActionLoading(true);
      setShowCheckinCheckout(true);
    } else if (name === 'make-current-version') {
      setVersionsActionLoading(true);
      handleUpdateCurrentVersion();
    } else if (name === 'download') {
      handleDownload();
    }
  };

  return (
    <ul className={componentClass}>
      <ActionsMenuItem
        icon={checkedInStatus === 'checked_in' ? 'bff-check-in' : 'bff-check-out'}
        text={checkedInStatus === 'checked_in' ? t('Check Out') : t('Check In')}
        isDisplayed={isLatestVersion}
        onSelect={handleOnSelect}
        name={checkedInStatus === 'checked_in' ? 'checked_out' : 'checked_in'}
      />
      <ActionsMenuItem
        icon="bff-refresh"
        text={t('Make current version')}
        isDisplayed={!isLatestVersion}
        onSelect={handleOnSelect}
        name="make-current-version"
      />
      <ActionsMenuItem
        icon="bff-download-asset"
        text={t('Download')}
        isDisplayed
        onSelect={handleOnSelect}
        name="download"
      />
    </ul>
  );
};

ActionsMenu.propTypes = {
  checkedInStatus: PropTypes.oneOf(['checked_in', 'checked_out']).isRequired,
  componentClass: PropTypes.string,
  initializeTab: PropTypes.func.isRequired,
  isLatestVersion: PropTypes.bool.isRequired,
  setShowActionsMenu: PropTypes.func.isRequired,
  setShowCheckinCheckout: PropTypes.func.isRequired,
  setVersionsActionLoading: PropTypes.func.isRequired,
  sidebarCard: PropTypes.shape({
    created_at: PropTypes.string,
    type: PropTypes.oneOf(['reservation', 'version']),
    id: PropTypes.string,
    version_details: PropTypes.shape({
      filename: PropTypes.string,
      metadata: PropTypes.shape({}),
      small_thumbnail: PropTypes.string,
      url: PropTypes.string,
    }),
    annotations: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf(['annotation', 'comment']),
    })),
  }).isRequired,
  updateFetchControllers: PropTypes.func.isRequired,
};

ActionsMenu.defaultProps = {
  componentClass: 'actions__menu',
};

export default ActionsMenu;
